import api from '@/services/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';

const useDeleteAnnouncement = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return useMutation({
    mutationKey: ['deleteAnnouncement'],
    mutationFn: (announcementId: string) => {
      return api.announcements.deleteAnnouncement(announcementId);
    },
    onError: (error) => {
      const errorMessage = error.message;
      toast.error(t('toast.error', { errorMessage }));
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['announcements'] });
      toast.success(t('toast.deletedAnnouncement'));
      navigate(-1);
    },
    retry: false
  });
};

export default useDeleteAnnouncement;
